// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media print{.tabs-container,.breadcrumbs{display:none !important}.questionnaire-result a,.questionnaire-result .btn,.questionnaire-result .legend{display:none !important}.questionnaire-result .file-store a{display:inline-block !important}.questionnaire-result thead{color:#000 !important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
